const FLOW_PARAM = 'flow';
const FLOW_LOGIN = 'login';

function readDeferredLoginFlow(searchParams) {
    const shouldFireDeferredLoginEvents = searchParams.get(FLOW_PARAM) === FLOW_LOGIN;
    const params = new URLSearchParams(searchParams);
    params.delete(FLOW_PARAM);

    return { shouldFireDeferredLoginEvents, params };
}

module.exports = {
    FLOW_PARAM,
    FLOW_LOGIN,
    readDeferredLoginFlow
};
